export const url = typeof window !== 'undefined' && window.PUBSUB_PATH && window.PUBSUB_PATH !== '' ? window.PUBSUB_PATH : '/bua';
export const delay = 3000;
